<script setup>
import { defineProps } from 'vue';
import CookieReset from '../../components/CookieReset.vue';
import { useCcm19Global } from '../../useCcm19Global';

defineProps({
    data: {
        type: Object,
        required: true
    }
});
const { onReady, youtube } = useCcm19Global();
onReady(() => {});
</script>

<template>
    <div>
        <YoutubePlayer v-if="youtube && data?.meta?.snippet?.resourceId?.videoId" :source="data.meta.snippet.resourceId.videoId" />
        <div v-else class="aspect-video rounded-xl relative border-2 border-gray-200 bg-gray-100 flex flex-col items-center justify-center text-center p-8">
            <CookieReset />
        </div>
    </div>
</template>
